// supabase-reviews.js v4.1 (with Cloudinary Upload)

class SupabaseProductReviews {
  constructor(element) {
    this.container = element;
    if (!this.container) return;

    // --- Configuration ---
    this.supabaseUrl = "https://penkozrfaxruujxpotdn.supabase.co";
    this.supabaseKey =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBlbmtvenJmYXhydXVqeHBvdGRuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM5NDIyNzYsImV4cCI6MjA2OTUxODI3Nn0.peEO1604jU2dxZD2ZQ1OYLUsxs8sNmK-7MIUQZ8E7Rw";
    this.productHandle = this.container.dataset.productHandle;
    this.reviewsPerPage = 6;

    // --- CLOUDINARY CONFIGURATION ---
    this.cloudinaryCloudName = "aeternum"; // <-- REPLACE WITH YOUR CLOUDINARY CLOUD NAME
    this.cloudinaryUploadPreset = "shopify_reviews"; // <-- REPLACE WITH YOUR UNSIGNED UPLOAD PRESET
    // --------------------------------

    this.allReviews = [];

    if (
      typeof supabase === "undefined" ||
      typeof supabase.createClient !== "function"
    ) {
      console.error("Supabase client not loaded.");
      this.showError("Initialization Error: Supabase client not found.");
      return;
    }

    this.sbClient = supabase.createClient(this.supabaseUrl, this.supabaseKey);

    this.cacheElements();
    this.init();
  }

  cacheElements() {
    this.reviewsContainer = this.container.querySelector(
      "#supabase-reviews-container",
    );
    this.emptyState = this.container.querySelector(
      "#supabase-reviews-empty-state",
    );
    this.loader = this.container.querySelector(".supabase-reviews__loader");
    this.summaryContainer = this.container.querySelector(
      ".supabase-reviews__summary",
    );
    this.footer = this.container.querySelector("#supabase-reviews-footer");
    this.writeReviewBtn = this.container.querySelector(".write-review-btn");
    this.writeModal = this.container.querySelector(".review-modal");
    this.closeWriteModalBtn = this.writeModal?.querySelector(
      ".review-modal__close",
    );
    this.reviewForm = this.container.querySelector("#review-form");
    this.formStars = this.container.querySelectorAll(".review-form__star");
    this.formRatingInput = this.container.querySelector('input[name="rating"]');
    this.formSubmitBtn = this.container.querySelector(".review-form__submit");
    this.viewAllBtn = this.container.querySelector(".view-all-reviews-btn");
    this.allReviewsModal = document.getElementById("all-reviews-modal");
    this.drawer = this.container.querySelector("[data-reviews-drawer]");
    this.drawerCloseButtons = this.container.querySelectorAll(
      "[data-reviews-drawer-close]",
    );
    this.closeAllReviewsModalBtn = this.allReviewsModal?.querySelector(
      ".all-reviews-modal__close",
    );
    this.allReviewsList = this.allReviewsModal?.querySelector(
      "#all-reviews-modal-list",
    );
    this.allReviewsEmpty = this.allReviewsModal?.querySelector(
      "#all-reviews-modal-empty",
    );
    this.searchInput = this.allReviewsModal?.querySelector(
      "#reviews-search-input",
    );
    this.sortSelect = this.allReviewsModal?.querySelector(
      "#reviews-sort-select",
    );
    this.modalSummaryPlaceholder = this.allReviewsModal?.querySelector(
      ".all-reviews-modal__summary-placeholder",
    );
    this.mediaInput = this.container.querySelector("#review-media");
    this.mediaPreview = this.container.querySelector("#media-upload-preview");
    this.mediaOnlyCheckbox = this.allReviewsModal?.querySelector(
      "#reviews-media-only",
    );
    if (this.mediaOnlyCheckbox) {
      this.mediaOnlyCheckbox.addEventListener("change", () =>
        this.applyFiltersAndSort(),
      );
    }
  }

  init() {
    if (!this.productHandle) {
      this.showError("Initialization failed. Product handle not found.");
      return;
    }
    this.attachEventListeners();
    this.fetchReviews();
  }

  attachEventListeners() {
    this.writeReviewBtn?.addEventListener("click", () => this.openWriteModal());
    this.closeWriteModalBtn?.addEventListener("click", () =>
      this.closeWriteModal(),
    );
    this.writeModal?.addEventListener("click", (e) => {
      if (e.target === this.writeModal) this.closeWriteModal();
    });
    this.drawerCloseButtons.forEach((button) => {
      button.addEventListener("click", () => this.closeDrawer());
    });
    this.reviewForm?.addEventListener("submit", (e) =>
      this.handleFormSubmit(e),
    );
    this.formStars.forEach((star) => {
      star.addEventListener("mouseover", (e) => this.handleStarHover(e));
      star.addEventListener("mouseout", () => this.resetStarDisplay());
      star.addEventListener("click", (e) => this.handleStarClick(e));
    });
    // View all button is now a link, no event listener needed
    this.closeAllReviewsModalBtn?.addEventListener("click", () =>
      this.closeAllReviewsModal(),
    );
    this.searchInput?.addEventListener("input", () =>
      this.applyFiltersAndSort(),
    );
    this.sortSelect?.addEventListener("change", () =>
      this.applyFiltersAndSort(),
    );
    this.mediaInput?.addEventListener("change", () =>
      this.handleMediaPreview(),
    );
    document.addEventListener("product:reviews:open", () => this.openDrawer());
    document
      .querySelectorAll("[data-open-reviews-drawer]")
      .forEach((trigger) => {
        trigger.addEventListener("click", (event) => {
          event.preventDefault();
          this.openDrawer();
        });
      });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        if (this.writeModal?.style.display === "flex") this.closeWriteModal();
        else if (this.allReviewsModal?.classList.contains("is-open")) {
          this.closeAllReviewsModal();
        } else if (this.drawer?.classList.contains("is-open")) {
          this.closeDrawer();
        }
      }
    });
    // Delegate click for review media (image/video)
    this.container.addEventListener("click", (e) => {
      const media = e.target.closest(
        ".supabase-review-card__media img, .supabase-review-card__media video",
      );
      if (media) {
        this.showMediaFullscreen(media);
      }
    });
  }

  handleMediaPreview() {
    const file = this.mediaInput.files[0];
    if (file) {
      const reader = new FileReader();
      this.mediaPreview.innerHTML = "";
      reader.onload = (e) => {
        let previewElement;
        if (file.type.startsWith("image/")) {
          previewElement = document.createElement("img");
        } else if (file.type.startsWith("video/")) {
          previewElement = document.createElement("video");
          previewElement.muted = true;
          previewElement.playsInline = true;
          previewElement.autoplay = true;
          previewElement.loop = true;
        }
        previewElement.src = e.target.result;
        this.mediaPreview.appendChild(previewElement);
        this.mediaPreview.style.display = "block";
      };
      reader.readAsDataURL(file);
    } else {
      this.mediaPreview.style.display = "none";
    }
  }

  async uploadToCloudinary(file) {
    const url = `https://api.cloudinary.com/v1_1/${this.cloudinaryCloudName}/upload`;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", this.cloudinaryUploadPreset);

    try {
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });
      if (!response.ok) throw new Error("Cloudinary upload failed");
      const data = await response.json();
      return data.secure_url;
    } catch (error) {
      console.error("Cloudinary Upload Error:", error);
      this.showFormMessage(
        "Could not upload media. Please try again.",
        "error",
      );
      return null;
    }
  }

  async handleFormSubmit(e) {
    e.preventDefault();
    this.setFormLoading(true);

    const formData = new FormData(this.reviewForm);
    const mediaFile = formData.get("media");
    let mediaUrl = null;

    if (mediaFile && mediaFile.size > 0) {
      this.showFormMessage("Uploading media...", "info");
      mediaUrl = await this.uploadToCloudinary(mediaFile);
      if (!mediaUrl) {
        this.setFormLoading(false);
        return;
      }
    }

    const reviewData = {
      author: formData.get("author") || "Anonymous",
      rating: parseInt(formData.get("rating"), 10),
      content: formData.get("content"),
      product_handle: this.productHandle,
      media_url: mediaUrl,
    };

    if (reviewData.rating === 0) {
      this.showFormMessage("Please select a rating.", "error");
      this.setFormLoading(false);
      return;
    }

    try {
      this.showFormMessage("Submitting review...", "info");
      const { error } = await this.sbClient
        .from("reviews")
        .insert([reviewData]);
      if (error) throw error;

      this.showFormMessage(
        "Thank you! Your review has been submitted.",
        "success",
      );
      setTimeout(() => {
        this.closeWriteModal();
        this.fetchReviews();
      }, 2000);
    } catch (error) {
      console.error("Submission Error:", error);
      this.showFormMessage("An error occurred. Please try again.", "error");
    } finally {
      this.setFormLoading(false);
    }
  }

  createReviewCard(review) {
    const reviewCard = document.createElement("div");
    reviewCard.className = "supabase-review-card";
    const formattedDate = new Date(review.created_at).toLocaleDateString(
      "en-US",
      {
        year: "numeric",
        month: "long",
        day: "numeric",
      },
    );
    const reviewAuthor = this.escapeHtml(review.author || "Anonymous");
    const reviewContent = this.escapeHtml(review.content || "");

    let mediaHtml = "";
    if (review.media_url) {
      // Cloudinary can transform videos to images, so we check if the URL indicates a video format
      const isVideo = review.media_url.match(/\.(mp4|webm|mov|m3u8)$/i) != null;
      if (isVideo) {
        mediaHtml = `<div class="supabase-review-card__media"><video src="${review.media_url}" muted playsinline controls loop></video></div>`;
      } else {
        // Use Cloudinary's transformation for a thumbnail
        const thumbnailUrl = review.media_url.replace(
          "/upload/",
          "/upload/w_300,h_300,c_fill,q_auto,f_auto/",
        );
        mediaHtml = `<div class="supabase-review-card__media"><img src="${thumbnailUrl}" alt="Review media" loading="lazy"></div>`;
      }
    }

    reviewCard.innerHTML = `
        <div class="supabase-review-card__main-content">
          <div class="supabase-review-card__content-wrapper">
            ${mediaHtml}
            <div class="supabase-review-card__text-content">
              <div class="supabase-review-card__header">
                <span class="supabase-review-card__author">${reviewAuthor}</span>
                <span class="supabase-review-card__date">${formattedDate}</span>
              </div>
              ${this.generateStarRating(review.rating, "card")}
              <p class="supabase-review-card__content">${reviewContent}</p>
            </div>
          </div>
        </div>
      `;
    return reviewCard;
  }

  escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  closeWriteModal() {
    if (!this.writeModal) return;
    this.writeModal.style.display = "none";
    this.unlockScroll();
    this.reviewForm?.reset();
    if (this.formRatingInput) this.formRatingInput.value = 0;
    this.resetStarDisplay();
    this.hideFormMessage();
    if (this.mediaPreview) {
      this.mediaPreview.innerHTML = "";
      this.mediaPreview.style.display = "none";
    }
  }

  openWriteModal() {
    if (!this.writeModal) return;
    this.writeModal.style.display = "flex";
    this.lockScroll();
  }
  openAllReviewsModal() {
    if (!this.allReviewsModal) return;
    this.allReviewsModal.style.display = "flex";
    setTimeout(() => this.allReviewsModal.classList.add("is-open"), 10);
    this.lockScroll();
    this.applyFiltersAndSort(); // Initial render
    this.initInfiniteScroll(); // Enable infinite scroll
  }
  closeAllReviewsModal() {
    if (!this.allReviewsModal) return;
    this.allReviewsModal.classList.remove("is-open");
    setTimeout(() => {
      this.allReviewsModal.style.display = "none";
      this.unlockScroll();
    }, 300);
  }
  openDrawer() {
    if (!this.drawer) return;
    this.drawer.style.display = "block";
    this.drawer.setAttribute("aria-hidden", "false");
    requestAnimationFrame(() => this.drawer.classList.add("is-open"));
    this.lockScroll();
  }
  closeDrawer() {
    if (!this.drawer) return;
    this.drawer.classList.remove("is-open");
    this.drawer.setAttribute("aria-hidden", "true");
    setTimeout(() => {
      this.drawer.style.display = "none";
      this.unlockScroll();
    }, 300);
  }
  lockScroll() {
    document.body.style.overflow = "hidden";
  }
  unlockScroll() {
    const writeOpen = this.writeModal?.style.display === "flex";
    const allReviewsOpen = this.allReviewsModal?.classList.contains("is-open");
    const drawerOpen = this.drawer?.classList.contains("is-open");
    if (!writeOpen && !allReviewsOpen && !drawerOpen) {
      document.body.style.overflow = "";
    }
  }
  async fetchReviews() {
    this.loader.style.display = "flex";
    this.reviewsContainer.innerHTML = "";
    this.emptyState.style.display = "none";
    try {
      const { data, error } = await this.sbClient
        .from("reviews")
        .select("*")
        .eq("product_handle", this.productHandle)
        .order("created_at", { ascending: false });
      if (error) throw error;
      this.allReviews = data;
      this.loader.style.display = "none";
      this.renderSummary(this.allReviews);
      this.renderPaginatedReviews(this.allReviews);
    } catch (error) {
      this.showError("Could not load reviews at this time.");
      console.error("Fetch Error:", error);
    }
  }
  applyFiltersAndSort() {
    let reviews = [...this.allReviews];
    const searchTerm = this.searchInput.value.toLowerCase();
    if (searchTerm) {
      reviews = reviews.filter(
        (review) =>
          (review.author && review.author.toLowerCase().includes(searchTerm)) ||
          (review.content && review.content.toLowerCase().includes(searchTerm)),
      );
    }
    const sortBy = this.sortSelect.value;
    reviews.sort((a, b) => {
      switch (sortBy) {
        case "highest":
          return b.rating - a.rating;
        case "lowest":
          return a.rating - b.rating;
        case "oldest":
          return new Date(a.created_at) - new Date(b.created_at);
        case "newest":
        default:
          return new Date(b.created_at) - new Date(a.created_at);
      }
    });
    // Media Only filter
    if (this.mediaOnlyCheckbox && this.mediaOnlyCheckbox.checked) {
      reviews = reviews.filter((review) => !!review.media_url);
    }
    this.renderAllReviews(reviews);
  }
  renderPaginatedReviews(reviews) {
    this.reviewsContainer.innerHTML = "";
    if (!reviews || reviews.length === 0) {
      this.emptyState.style.display = "block";
      this.footer.style.display = "none";
    } else {
      const reviewsToShow = reviews.slice(0, this.reviewsPerPage);
      reviewsToShow.forEach((review) =>
        this.reviewsContainer.appendChild(this.createReviewCard(review)),
      );
      // Only show footer if there are more reviews than displayed
      if (reviews.length > this.reviewsPerPage) {
        this.footer.style.display = "block";
        // Update the button text and href
        if (this.viewAllBtn) {
          this.viewAllBtn.textContent = `View All Review${
            reviews.length > 1 ? "s" : ""
          }`;
          this.viewAllBtn.href = `/pages/reviews?product=${this.productHandle}`;
        }
      } else {
        this.footer.style.display = "none";
      }
    }
  }
  renderAllReviews(reviews) {
    this.allReviewsList.innerHTML = "";
    if (!reviews || reviews.length === 0) {
      this.allReviewsEmpty.style.display = "block";
    } else {
      this.allReviewsEmpty.style.display = "none";
      reviews.forEach((review) =>
        this.allReviewsList.appendChild(this.createReviewCard(review)),
      );
    }
  }
  renderSummary(reviews) {
    if (!reviews || reviews.length === 0) {
      this.summaryContainer.style.display = "none";
      this.updateExternalReviewSummaries(null, 0);
      return;
    }
    const totalReviews = reviews.length;
    const averageRating =
      reviews.reduce((acc, r) => acc + r.rating, 0) / totalReviews;
    const summaryHtml = `<div class="summary__stars">${this.generateStarRating(
      averageRating,
      "summary",
    )}</div><div class="summary__text">${averageRating.toFixed(
      1,
    )} out of 5 (${totalReviews} review${totalReviews > 1 ? "s" : ""})</div>`;
    this.summaryContainer.innerHTML = summaryHtml;
    this.summaryContainer.style.display = "flex";
    if (this.modalSummaryPlaceholder) {
      this.modalSummaryPlaceholder.innerHTML = summaryHtml;
    }
    this.updateExternalReviewSummaries(averageRating, totalReviews);
  }

  updateExternalReviewSummaries(averageRating, totalReviews) {
    const summaries = document.querySelectorAll(
      `[data-supabase-reviews-summary][data-product-handle="${this.productHandle}"]`,
    );

    summaries.forEach((summary) => {
      const textNode = summary.querySelector(
        "[data-supabase-reviews-summary-text]",
      );
      const labelNode = summary.querySelector(
        "[data-supabase-reviews-summary-label]",
      );

      if (!averageRating || !totalReviews) {
        summary.hidden = true;
        if (textNode) textNode.textContent = "";
        if (labelNode) labelNode.textContent = "";
        return;
      }

      const formattedRating = averageRating.toFixed(1);
      const reviewLabel = `${totalReviews} review${totalReviews > 1 ? "s" : ""}`;
      const visibleText = `★ ${formattedRating} (${totalReviews})`;
      const accessibleText = `${formattedRating} out of 5 stars, ${reviewLabel}`;

      summary.hidden = false;
      summary.setAttribute("aria-label", accessibleText);
      if (textNode) textNode.textContent = visibleText;
      if (labelNode) labelNode.textContent = accessibleText;
    });
  }
  handleStarHover(e) {
    const rating = e.currentTarget.dataset.value;
    this.updateStarDisplay(rating);
  }
  handleStarClick(e) {
    const rating = e.currentTarget.dataset.value;
    this.formRatingInput.value = rating;
    this.updateStarDisplay(rating);
  }
  updateStarDisplay(rating) {
    this.formStars.forEach((star) => {
      const starSvg = star.querySelector("svg");
      if (star.dataset.value <= rating) {
        starSvg.classList.add("is-filled");
      } else {
        starSvg.classList.remove("is-filled");
      }
    });
  }
  resetStarDisplay() {
    const currentRating = this.formRatingInput.value;
    this.updateStarDisplay(currentRating);
  }
  setFormLoading(isLoading) {
    if (!this.formSubmitBtn) return;
    this.formSubmitBtn.disabled = isLoading;
    this.formSubmitBtn.textContent = isLoading
      ? "Submitting..."
      : "Submit Review";
  }
  showFormMessage(message, type = "info") {
    const messageEl = this.container.querySelector(".review-form__message");
    if (!messageEl) return;
    messageEl.textContent = message;
    messageEl.className = `review-form__message review-form__message--${type}`;
    messageEl.style.display = "block";
  }
  hideFormMessage() {
    const messageEl = this.container.querySelector(".review-form__message");
    if (messageEl) messageEl.style.display = "none";
  }
  generateStarRating(rating, type) {
    let starsHTML = "";
    const totalStars = 5;
    const normalizedRating = Math.max(0, Math.min(totalStars, rating || 0));
    const roundedRating =
      type === "summary"
        ? Math.round(normalizedRating * 2) / 2
        : normalizedRating;
    for (let i = 1; i <= totalStars; i++) {
      let starSVG;
      if (i <= roundedRating) {
        starSVG = this.getStarSVG("filled");
      } else if (i - 0.5 === roundedRating) {
        starSVG = this.getStarSVG("half");
      } else {
        starSVG = this.getStarSVG("empty");
      }
      starsHTML += starSVG;
    }
    const ratingClass =
      type === "summary"
        ? "supabase-review-stars--summary"
        : "supabase-review-stars--card";
    return `<div class="supabase-review-stars ${ratingClass}">${starsHTML}</div>`;
  }
  getStarSVG(type) {
    const colors = { filled: "#ffc107", empty: "#ccc" };
    if (type === "half") {
      return ` <svg viewBox="0 0 24 24" > <defs> <linearGradient id="supabase-review-half-grad"> <stop offset="50%" stop-color="${colors.filled}" /> <stop offset="50%" stop-color="${colors.empty}" stop-opacity="1" /> </linearGradient> </defs> <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" fill="url(#supabase-review-half-grad)" stroke="${colors.filled}" stroke-width="1"/> </svg>`;
    }
    const color = type === "filled" ? colors.filled : "none";
    const strokeColor = type === "filled" ? colors.filled : colors.empty;
    return ` <svg viewBox="0 0 24 24" fill="${color}" stroke="${strokeColor}" stroke-width="1"> <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon> </svg>`;
  }
  showError(message) {
    this.loader.style.display = "none";
    this.reviewsContainer.innerHTML = `<p style="color: red; text-align: center;">${message}</p>`;
  }
  showMediaFullscreen(mediaElement) {
    // Remove any existing overlay
    if (this.fullscreenOverlay) this.fullscreenOverlay.remove();
    const overlay = document.createElement("div");
    overlay.className = "review-media-fullscreen-overlay";
    overlay.style.cssText = `
      position: fixed; z-index: 9999; top: 0; left: 0; width: 100vw; height: 100vh;
      background: rgba(0,0,0,0.85); display: flex; align-items: center; justify-content: center; cursor: zoom-out;`;
    let clone;
    if (mediaElement.tagName === "IMG") {
      clone = document.createElement("img");
      clone.src = mediaElement.src.replace(/w_\d+,h_\d+,c_fill,?/, ""); // show original if thumb
      clone.alt = mediaElement.alt || "Review media";
      clone.style.maxWidth = "90vw";
      clone.style.maxHeight = "90vh";
    } else if (mediaElement.tagName === "VIDEO") {
      clone = document.createElement("video");
      clone.src = mediaElement.src;
      clone.controls = true;
      clone.autoplay = true;
      clone.style.maxWidth = "90vw";
      clone.style.maxHeight = "90vh";
    }
    overlay.appendChild(clone);
    document.body.appendChild(overlay);
    this.fullscreenOverlay = overlay;
    // Close on click outside or ESC
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) overlay.remove();
    });
    document.addEventListener("keydown", function escListener(ev) {
      if (ev.key === "Escape") {
        overlay.remove();
        document.removeEventListener("keydown", escListener);
      }
    });
  }
  // Infinite scroll for all reviews modal
  initInfiniteScroll() {
    if (!this.allReviewsList) return;
    this.infiniteScrollPage = 1;
    this.infiniteScrollLoading = false;
    this.infiniteScrollEnd = false;
    this.allReviewsList.addEventListener("scroll", async () => {
      if (this.infiniteScrollLoading || this.infiniteScrollEnd) return;
      const { scrollTop, scrollHeight, clientHeight } = this.allReviewsList;
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        this.infiniteScrollLoading = true;
        await this.loadMoreReviews();
        this.infiniteScrollLoading = false;
      }
    });
  }

  async loadMoreReviews() {
    // Fetch next page of reviews from Supabase
    const pageSize = 10;
    const from = this.infiniteScrollPage * pageSize;
    const to = from + pageSize - 1;
    const { data, error } = await this.sbClient
      .from("reviews")
      .select("*")
      .eq("product_handle", this.productHandle)
      .order("created_at", { ascending: false })
      .range(from, to);
    if (error || !data || data.length === 0) {
      this.infiniteScrollEnd = true;
      return;
    }
    data.forEach((review) => {
      this.allReviewsList.appendChild(this.createReviewCard(review));
    });
    this.infiniteScrollPage++;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const reviewSections = document.querySelectorAll(".supabase-reviews-section");
  reviewSections.forEach((reviewSection) => {
    if (!reviewSection.dataset.initialized) {
      new SupabaseProductReviews(reviewSection);
      reviewSection.dataset.initialized = true;
    }
  });
});

document.addEventListener("shopify:section:load", (event) => {
  const reviewSection = event.target.querySelector(".supabase-reviews-section");
  if (reviewSection && !reviewSection.dataset.initialized) {
    new SupabaseProductReviews(reviewSection);
    reviewSection.dataset.initialized = true;
  }
});
